import React, { useState } from "react";
import { getInputedValue, reloadPage } from "../../controllers/controller.utils";
import { handleLogin } from "../../controllers/controller.user";
import { useDispatch } from "react-redux";
import { AlertCircle, LogIn, Phone, Lock, Eye, EyeOff } from "lucide-react";

export default function Login() {
    const [tel, setTel] = useState('');
    const [pwd, setPwd] = useState('');
    const [disable, setDisable] = useState(false);
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [showPwd, setShowPwd] = useState(false);
    const [rememberMe, setRememberMe] = useState(true);

    async function login(e) {
        e.preventDefault();
        setError('');
        if(!tel || !pwd) {
            setError('Veuillez remplir tous les champs');
            return;
        }
        setDisable(true);
        try {
            let res = await handleLogin(e, tel, pwd, rememberMe);
            if (res !== -1) {
                dispatch(res);
                reloadPage();
            } else {
                setError('Identifiants incorrects');
            }
        } catch (err) {
            setError('Erreur de connexion');
        }
        setDisable(false);
    }

    return (
        <div className="flex min-h-screen bg-gray-50 font-sans">
            <div className="flex flex-col justify-center flex-1 px-4 py-12 sm:px-6 lg:px-8 z-10 w-full relative">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="flex justify-center">
                        <img 
                            src="/assets/images/logo.png" 
                            alt="Kalan Yoro Logo" 
                            className="w-24 h-auto object-contain drop-shadow-md mb-2" 
                        />
                    </div>
                    <h2 className="mt-2 text-3xl font-bold text-center text-gray-900 tracking-tight">
                        KalanYoro <span className="text-indigo-600">Admin</span>
                    </h2>
                    <p className="mt-2 text-sm text-center text-gray-600">
                        Connectez-vous pour accéder au tableau de bord
                    </p>
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="px-6 py-8 sm:px-10 bg-white shadow border border-gray-200 rounded-xl sm:rounded-2xl">
                        <form className="space-y-6" onSubmit={login}>
                            {error && (
                                <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2">
                                    <AlertCircle className="w-4 h-4 shrink-0" />
                                    <span>{error}</span>
                                </div>
                            )}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Numéro de téléphone
                                </label>
                                <div className="mt-2 relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Phone className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        type="tel"
                                        required
                                        onChange={(e) => getInputedValue(e, setTel)}
                                        className="block w-full pl-10 pr-4 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition-all sm:text-sm"
                                        placeholder="77 000 00 00"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Mot de passe
                                </label>
                                <div className="mt-2 relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Lock className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        type={showPwd ? "text" : "password"}
                                        required
                                        onChange={(e) => getInputedValue(e, setPwd)}
                                        className="block w-full pl-10 pr-10 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition-all sm:text-sm"
                                        placeholder="••••••••"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPwd(!showPwd)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        {showPwd ? (
                                            <EyeOff className="h-5 w-5" />
                                        ) : (
                                            <Eye className="h-5 w-5" />
                                        )}
                                    </button>
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <input
                                        id="remember-me"
                                        name="remember-me"
                                        type="checkbox"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                        className="w-4 h-4 text-indigo-600 bg-white border-gray-300 rounded focus:ring-indigo-600"
                                    />
                                    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                                        Se souvenir de moi
                                    </label>
                                </div>

                                <div className="text-sm">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    {/* <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors">
                                        Oublié ?
                                    </a> */}
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    disabled={disable}
                                    className="flex justify-center w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed group shadow-sm"
                                >
                                    <div className="flex items-center gap-2">
                                        {disable ? 'Connexion en cours...' : 'Se connecter'}
                                        {!disable && <LogIn className="w-5 h-5 ml-1 group-hover:translate-x-1 transition-transform" />}
                                    </div>
                                </button>
                            </div>
                        </form>

                        {/* <div className="mt-8 text-center text-sm text-gray-600">
                            Pas encore de compte ?{' '}
                            <a href="/signin" className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors">
                                Demander un accès
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}